import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { fetchTeamById, Team } from '../services/teams';

export function useTeamById(teamId: string): UseQueryResult<Team> {
  return useQuery({
    queryKey: ['team', teamId],
    queryFn: () => fetchTeamById(teamId),
    enabled: Boolean(teamId),
  });
}
